export type FontLoaderProps = {
  brand: string;
};

export const FontLoader = (brand: string) => {
  const insideIframe = InIframe();
  if (typeof document !== "undefined" && insideIframe && document && document.createElement) {
    const fonts = document.createElement("link");
    fonts.setAttribute("href", "../static/fonts/" + brand + "/index.css");
    fonts.setAttribute("rel", "stylesheet");
    document.head.appendChild(fonts);
  }
};

function InIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export default FontLoader;
